import { DefaultValue, selector } from "recoil";

import {
  changeI18nLang,
  Log,
  setLangLocalStorage,
  validatedLanguage,
} from "../../helpers";
import { SupportedLanguage } from "../../models";
import { appLanguageAtom } from "../atoms";

export const appLanguageSelector = selector<SupportedLanguage>({
  key: "appLanguageSelector",
  get: ({ get }) => {
    const lang = get(appLanguageAtom);
    return lang;
  },
  set: ({ set, reset }, newLang) => {
    if (newLang instanceof DefaultValue) {
      reset(appLanguageAtom);
      return;
    }

    const validatedLang = validatedLanguage(newLang);

    // Ignore clear/invalid values so the header switcher cannot disappear.
    if (!validatedLang) {
      return;
    }

    changeI18nLang(validatedLang);
    Log.debug(`Change language  to ${validatedLang}`);
    set(appLanguageAtom, validatedLang);
    setLangLocalStorage(validatedLang);
  },
});
